/**
 * Test IDs for QA automation.
 */
export const testIds = {
  invoicePaymentFormModalCancel: "invoice-payment-form-modal-cancel",
  invoicePaymentFormModalValidate: "invoice-payment-form-modal-validate",
} as const;
